import { makeAutoObservable } from 'mobx'

/** Store that manages the sign-in modal state and callbacks */
class SignInModalStore {
    public isOpen: boolean = false
    private onAfterLogin: () => void

    public constructor() {
        makeAutoObservable(this)
    }

    /**
     * Opens the sign-in modal and sets the callback to be executed after successful login
     * @param {() => void} [onAfterLogin] - Optional callback function to execute after successful login. Default is an empty function.
     */
    public openSignInModal = (onAfterLogin: () => void = () => {}) => {
        this.isOpen = true
        this.onAfterLogin = onAfterLogin
    }

    /** Closes the sign-in modal */
    public closeSignInModal = () => {
        this.isOpen = false
    }

    /** Executes the stored post-login callback and resets it */
    public runPostLoginCallback = () => {
        this.onAfterLogin()
        this.onAfterLogin = () => {}
    }
}

export const signInModalStore = new SignInModalStore()
